import { useAuthService } from '@invivodf/front-seller-auth'
import { Zones } from '@invivodf/module-logistic-interfaces'
import sdk, { LogisticExclusionZoneSdk } from '@invivodf/module-logistic-exclusion-zone-sdk'
import { buildCallerId } from '@invivodf/front-seller-caller-id'

class ExclusionZonesRepository {
  private logisticExclusionZoneSdk: LogisticExclusionZoneSdk

  constructor({ logisticApiHost }) {
    this.logisticExclusionZoneSdk = sdk(logisticApiHost, {
      callerId: buildCallerId(),
      accessTokenSource: () => useAuthService().getAccessToken(),
    })
  }

  getAll(): Promise<Zones> {
    return this.logisticExclusionZoneSdk.getExclusionZones()
  }
}

export default ExclusionZonesRepository
